import api_call_v2 from "utils/API_CALL/api_call_v2";
import PROXY_CONFIG from "../../Config/ProxyConfig";

const GetData = async (properties) => {
  let region = properties.region;
  let province = properties.province;
  let commune = properties.commune;
  let quartier = properties.quartier;
  // if(!properties.prix_appartement && !properties.prix_villa){
  //     quartier = null;
  //     commune = null;
  // }
  return new Promise((resolve, reject) => {

    api_call_v2(
      undefined,
      "post",
      "prix-immobilier/data",
      {
        data: encrypt({

          region,
          province,
          commune,
          quartier,


        })
      }

    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {

        reject(err);
      });
  });
};

export default GetData;
